<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <!-- <v-tooltip
        v-if="claims.report['ROLE_GET_REPORT_RECEIPT']"
        slot="append"
        top
      >
        <v-btn
          color="gray-6"
          flat
          icon
          slot="activator"
          @click="handleViewReceipt"
        >
          <v-icon>receipt</v-icon>
        </v-btn>
        <span>{{ $t(`${namespace}.receiptTooltip`) }}</span>
      </v-tooltip> -->

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports.header'
    }
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    },

    close () {
      this.$emit('close')
    },

    handleViewReceipt () {
      console.log('TO DO')
    }
  }
}
</script>
